
import { defineComponent, onMounted, ref, computed, getCurrentInstance } from 'vue';
import { CaptionItemSeoSetup } from './scripts/seo';
import { CaptionItemAppSetup } from './scripts/app';

export default defineComponent({
    components: {},
    props: {
        caption: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() || {};
        const setupConfig = proxy?.$isAppEnvironment ? CaptionItemAppSetup(props) : CaptionItemSeoSetup(props);

        const textRef = ref<HTMLDivElement>();
        const showMoreBtn = ref(false); // 展示more按钮
        const showHideBtn = ref(false); // 展示hide按钮
        const showClampStyle = ref(true); // 展示折叠样式

        onMounted(async () => {
            if (!textRef?.value) return;

            const height = textRef.value?.scrollHeight || 0;
            const lineHeight = Number(window.getComputedStyle(textRef?.value).lineHeight.match(/\d+\.*\d+/g)?.[0]) || 1;
            if (height / lineHeight >= 4) {
                showMoreBtn.value = true;
            }
        });

        const onMoreBtnClick = () => {
            showClampStyle.value = false;
            showHideBtn.value = true;
            showMoreBtn.value = false;
        };

        const onHideBtnClick = () => {
            showClampStyle.value = true;
            showHideBtn.value = false;
            showMoreBtn.value = true;
        };

        return {
            hashtagLinksText: setupConfig.hashtagLinksText,
            textRef,
            showMoreBtn,
            showHideBtn,
            showClampStyle,

            onMoreBtnClick,
            onHideBtnClick,
        };
    },
});
